import { namespacer } from 'util/namespace';
import { TW_API_URL } from 'config';

const NAMESPACE = 'PAGES_STANDINGS';

export const GET_STANDINGS_REQUEST_START = namespacer(
  NAMESPACE,
  'GET_STANDINGS_REQUEST_START'
);
export const GET_STANDINGS_REQUEST_SUCCESS = namespacer(
  NAMESPACE,
  'GET_STANDINGS_REQUEST_SUCCESS'
);
export const GET_STANDINGS_REQUEST_ERROR = namespacer(
  NAMESPACE,
  'GET_STANDINGS_REQUEST_ERROR'
);

export function getStandingsRequestStart() {
  return {
    type: GET_STANDINGS_REQUEST_START,
  };
}

export function getStandingsRequestSuccess(standings) {
  return {
    type: GET_STANDINGS_REQUEST_SUCCESS,
    standings,
  };
}

export function getStandingsRequestError(error) {
  return {
    type: GET_STANDINGS_REQUEST_ERROR,
    error,
  };
}

export function getStandingsRequest(season, week) {
  return (dispatch) => {
    dispatch(getStandingsRequestStart());

    const url = `${TW_API_URL}/twdt/standings?season=${season}&week=${week}`;

    return fetch(url)
      .then((data) => data.json())
      .then((teams) => ({
        week,
        teams: Array.isArray(teams)
          ? teams.map((team) => ({
              fnTeamID: team.fnTeamID,
              name: team.fcTeamName,
              points: team.points,
              games: team.games,
              rank: team.rank,
              prevrank: team.prevrank,
              leaguerank: team.leaguerank,
              imgUrl: team.fcImageURL,
              cap: team.fcCap,
              eliminated: (team.rank > 6 ? true : false),
            }))
          : [],
      }))
      .then((standings) => {
        dispatch(getStandingsRequestSuccess(standings));
      })
      .catch((error) => {
        console.log('ERROR', error);
        dispatch(getStandingsRequestError(error));
      });
  };
}



// WEBPACK FOOTER //
// ./src/actions/pages/standings.js